import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import * as contactActions from "@rentiohq/shared-frontend/dist/redux/contact/contact.actions";
import * as contactSelectors from "@rentiohq/shared-frontend/dist/redux/contact/contact.selectors";
import { IPartialRootState } from "@rentiohq/shared-frontend/dist/redux/types";
import {
  Box,
  MainCard,
  Form,
} from "@rentiohq/web-shared-next/dist/ui-components";
import { useDispatch, useSelector } from "react-redux";
import { trimAllValuesInObject } from "../../Profile.utils";
import { profileExtraSchema } from "./profileExtraForm/schema.profileExtra.list";

export const ProfileExtra = () => {
  const { user } = authHooks.useSelf();

  const dispatch = useDispatch();

  const isSubmitting = useSelector((state: IPartialRootState) =>
    contactSelectors.contactIsUpdating(state, user?.personalContactId!),
  );

  if (!user) {
    return null;
  }

  const handleSubmit = async (values: any) => {
    const { dateOfBirth, placeOfBirth, countryOfBirth, nationality } = values;

    const input = {
      placeOfBirth,
      countryOfBirth,
      dateOfBirth: dateOfBirth ?? null,
      nationality,
    };

    dispatch(
      contactActions.updateContact.actions.start({
        contactId: user.personalContactId!,
        contact: trimAllValuesInObject(input),
      }),
    );
  };
  return (
    <MainCard>
      <Box sx={{ maxWidth: "600px" }}>
        <Form
          onSubmit={handleSubmit}
          getSchema={profileExtraSchema(user)}
          isSubmitting={isSubmitting}
        />
      </Box>
    </MainCard>
  );
};
